import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios'
import { Markup } from 'interweave';
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../Dashboard.css';
import classes from "./Webpages.module.css";
import styles from '../Dashboard.module.css';
import 'react-tagsinput/react-tagsinput.css'

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";
import LoadMoreButton from "../../Global/LoadMoreButton";

import noThumb from "../../../images/no-thumb.jpg";

function Webpages() {
    const navigate = useNavigate();
    const [weblinks, setWeblinks] = useState([]);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get('logged_user');

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/myweblinks.php`, {
            page: 1,
            user_id: logged_user,
            action: 'GET_MY_WEBLINKS'
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            setWeblinks(res.data);

            res.data.data < 10 ? sethasMore(false) : sethasMore(true);
            setProgress(100);
            setLoading(true);
        })
    } , [])

    const loadMore = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/myweblinks.php`, {
            page: page,
            limit: 10,
            user_id: logged_user,
            action: 'GET_MY_WEBLINKS'
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                if(res.data.message !== 'No weblinks found') {
                    loading && hasMore && setWeblinks([...weblinks, ...res.data]);
                    setpage(page + 1);
                    
                    res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                }else {
                    sethasMore(false)
                }

            })
        }

    const handleDelete = (id) => {
        const video = document.getElementById(`weblink_${id}`);
        if(video) {
            if(window.confirm("Are you sure you want to delete this video?")) {
                const toast_id = toast.loading("Please wait...");
                axios.post(`${process.env.REACT_APP_API_URL}/api/user/myweblinks.php`, {
                        user_id: logged_user,
                        weblink_id: id,
                        action: 'DELETE_MY_WEBLINK'
                    }, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(res => {
                        toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
                        if(res.data.status === 'success') {
                            video.remove();
                        }
                    })
            }
        }
    }

    return (
        <>
            <Helmet>
                <title>Webpages</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <ToastContainer />
                    <Sidebar active="webpages" />
                    <div className={styles.main_content}>
                        <div className={styles.content_body}>
                            <div className={classes.page_name}>
                                        <h3>My WebPages</h3>
                                    </div>
                                    <div className={styles.card}>
                                        <div className={`card-body ${classes.card_body}`}>
                                            <table className={`table ${classes.table}`}>
                                                <thead>
                                                    <tr>
                                                        <th>Thumbnails</th>
                                                        <th className={classes.title}>Website Title</th>
                                                        <th>Website URL</th>
                                                        <th className={classes.group_name}>Website Group</th>
                                                        <th className={classes.action}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        weblinks && weblinks.map ? weblinks.map((weblink, index) => {
                                                            return (
                                                                <tr id={`weblink_${weblink.id}`} key={index}>
                                                                    <td><img className={classes.group_thumb} src={weblink.thumb} alt="" /></td>
                                                                    <td><strong className='text-muted'><Markup content={weblink.webTitle} /></strong></td>
                                                                    <td>{weblink.webUrl}</td>
                                                                    <td>{weblink.groupName}</td>
                                                                    <td>
                                                                        <Link className="btn btn-sm btn-outline btn-info " to={`/dashboard/editwebpage/${weblink.id}`} title="Edit"><i className="icon-edit"></i>Edit</Link>
                                                                        <button className="btn btn-sm btn-outline btn-danger" onClick={() => handleDelete(weblink.id)}><i className="icon-trash"></i>Delete</button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                        : <tr><td colSpan='3' align='center' className='text-muted'>Nothing to see here</td></tr>
                                                    }
                                                </tbody>
                                            </table>
                                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                                {
                                                    hasMore && <span onClick={loadMore}><LoadMoreButton text="Load more..." /></span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                        </div>
                    <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Webpages;